import React, { useEffect, useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import * as bootstrap from "bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { fetchRecentPeople, fetchUserBalance } from "../../services/api";
import { User, EnvelopeSimple, Wallet, ArrowDownLeft, ArrowUpRight, EyeClosed, Eye, CopySimple } from "phosphor-react";

const ProfileInfo = ({ userData, onSelectPerson }) => {
  const [people, setPeople] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);

  // Password and balance states
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [balance, setBalance] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const loadPeople = async () => {
      try {
        const storedUserId = localStorage.getItem("userId");
        const data = await fetchRecentPeople(storedUserId);
        setPeople(data);
      } catch (error) {
        console.error("Failed to load people:", error);
      } finally {
        setLoading(false);
      }
    };
    loadPeople();
  }, []);

  useEffect(() => {
    const tooltips = document.querySelectorAll('[title]');
    tooltips.forEach(el => {
      new bootstrap.Tooltip(el);
    });
  }, []);
  const visiblePeople = showAll ? people.slice(0, 10) : people.slice(0, 5);

  const handleCheckBalance = async () => {
    setBalanceLoading(true);
    setPasswordError("");
    setBalance(null);

    try {
      const token = localStorage.getItem("adminToken");
      const storedUserId = localStorage.getItem("userId");

      const result = await fetchUserBalance(storedUserId, password, token);
      setBalance(result.balance);
      setVerified(true);
      setPassword("");

      // Close modal using button click
      const closeButton = document.querySelector('#viewBalanceModal .btn-close');
      if (closeButton) {
        closeButton.click();
      }
    } catch (error) {
      console.error("Balance fetch failed:", error);
      setPasswordError(error.message || "Invalid password. Please try again.");
    } finally {
      setBalanceLoading(false);
    }
  };

  const handleModalClose = () => {
    setPassword("");
    setPasswordError("");
    setShowPassword(false);
  };

  const toggleBalanceVisibility = () => {
    setVerified(false);
    setBalance(null);
  };

  return (
    <>
      <div className="profile-info container-fluid px-0">
        <div className='row'>
          <div className='col-md-12'>
            <div className='dashborad-grid'>
              <div className='sm-box-big'>
                <div className='theme-card-white h-100 dash-card'>
                  <div className="move-inner">
                    <div className='dash-content-top'>
                      <div className="balance-main">
                        <p className="dash-card-text">
                          {verified && balance !== null ? `₹${balance.toFixed(2)}` : "$******"}
                        </p>
                        <a
                          href="#"
                          className="view-balance d-inline-flex align-items-center gap-2"
                          data-bs-toggle={!verified ? "modal" : undefined}
                          data-bs-target={!verified ? "#viewBalanceModal" : undefined}
                          data-bs-placement="bottom"
                          title="Click Me"
                          onClick={(e) => {
                            e.preventDefault();
                            if (verified) {
                              toggleBalanceVisibility();
                            }
                          }}
                        >
                          {verified ? <Eye weight="bold" /> : <EyeClosed weight="bold" />}
                        </a>
                      </div>
                      <div className="dash-card-icon"><Wallet /></div>
                    </div>
                    <div className="dash-card-content">
                      <h5 className="text-xxl font-600 theme-text-black mb-1">Wallet Balance</h5>
                      <small className="text-sm d-block font-400 theme-text-black">Represents the total number of users registered on the platform.</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className='sm-box-big'>
                <div className='theme-card-white h-100 dash-card'>
                  <div className="move-inner">
                    <div className='dash-content-top'>
                      <p className="dash-card-text">₹509.00</p>
                      <div className="dash-card-icon"><ArrowDownLeft /></div>
                    </div>
                    <div className="dash-card-content">
                      <h5 className="text-xxl font-600 theme-text-black mb-1">Credit</h5>
                      <small className="text-sm d-block font-400 theme-text-black">Shows the cumulative count of all transactions successfully processed.</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className='sm-box-big'>
                <div className='theme-card-white h-100 dash-card'>
                  <div className="move-inner">
                    <div className='dash-content-top'>
                      <p className="dash-card-text">₹266.00</p>
                      <div className="dash-card-icon"><ArrowUpRight /></div>
                    </div>
                    <div className="dash-card-content">
                      <h5 className="text-xxl font-600 theme-text-black mb-1">Debit</h5>
                      <small className="text-sm d-block font-400 theme-text-black">Displays the combined wallet balance of all users.</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className='lg-box-big'>
                <div className='theme-card-white h-100 recents-people'>
                  <div className='theme-card-header'>
                    <h5 className="card-head">Recents</h5>
                  </div>
                  <div>
                    {loading ? (
                      <p className="text-center text-muted py-3">Loading people...</p>
                    ) : people.length === 0 ? (
                      <p className="text-center text-muted py-3">
                        No transactions yet.
                      </p>
                    ) : (
                      <>
                        <AnimatePresence mode="wait">
                          <motion.div
                            key={showAll ? "expanded" : "collapsed"}
                            initial={{ opacity: 0, scale: 0.98, y: 20 }}
                            animate={{
                              opacity: 1,
                              scale: 1,
                              y: 0,
                              transition: { type: "spring", stiffness: 120, damping: 15 },
                            }}
                            exit={{ opacity: 0, scale: 0.98, y: 20 }}
                            className="row g-3"
                          >
                            {visiblePeople.map((person) => (
                              <motion.div
                                key={person.id}
                                whileHover={{
                                  scale: 1.05,
                                  transition: { type: "spring", stiffness: 300 },
                                }}
                                onClick={() => onSelectPerson(person)}
                                className="col-12 col-sm-6 col-lg-4"
                              >
                                <div className="person-card d-flex align-items-center shadow-sm">
                                  <div className="person-avatar">
                                    <FaUserCircle />
                                  </div>
                                  <div>
                                    <p className="fw-semibold mb-0 theme-text-black">
                                      {person.name}
                                    </p>
                                    <small className="text-muted">
                                      Tap to pay or view
                                    </small>
                                  </div>
                                </div>
                              </motion.div>
                            ))}
                          </motion.div>
                        </AnimatePresence>

                        {people.length > 5 && (
                          <div className="mt-4 text-center">
                            <button
                              onClick={() => setShowAll(!showAll)}
                              className="toggle-btn-cstm"
                            >
                              {showAll ? "Show Less ▲" : "View More ▼"}
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className='sm-box-big'>
                <div className='theme-card-white h-100'>
                  <div className='theme-card-header'>
                    <h5 className="card-head">Profile Info</h5>
                  </div>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="profile-user">
                      <div className='profie-img'>
                        <span>N</span>
                      </div>
                    </div>
                    <div className="profile-user-content">
                      <div className="profile-content-inner">
                        <div className="profile-content-icon"><User /></div>
                        <p>{userData.name}</p>
                      </div>
                      <div className="profile-content-inner">
                        <div className="profile-content-icon"><EnvelopeSimple /></div>
                        <p>{userData.email}</p>
                        <a
                          className="copy-link"
                          style={{ cursor: "pointer" }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Copy email"
                          onClick={(e) => {
                            e.preventDefault();

                            const el = e.currentTarget; // ✅ capture DOM element

                            navigator.clipboard.writeText(userData.email);

                            let tooltip =
                              bootstrap.Tooltip.getInstance(el) ||
                              new bootstrap.Tooltip(el);

                            el.setAttribute("data-bs-original-title", "Copied!");
                            tooltip.show();

                            setTimeout(() => {
                              tooltip.hide();
                              el.setAttribute("data-bs-original-title", "Copy email");
                            }, 1200);
                          }}
                        >
                          <CopySimple />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="viewBalanceModal"
        tabIndex="-1"
        aria-labelledby="viewBalanceModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="viewBalanceModalLabel">
                Enter password to view balance
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleModalClose}
              />
            </div>

            <div className="modal-body">
              <div className="position-relative">
                <label className="form-label">
                  Password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control pe-5"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPasswordError("");
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && !balanceLoading && password) {
                      handleCheckBalance();
                    }
                  }}
                />
                <div
                  className="password-show-btn"
                  style={{ cursor: 'pointer' }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Eye size={18} /> : <EyeClosed size={18} />}
                </div>
              </div>
              {passwordError && (
                <div className="alert alert-danger mt-3 mb-0" role="alert">
                  {passwordError}
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="border-btn"
                data-bs-dismiss="modal"
                onClick={handleModalClose}
              >
                Close
              </button>
              <button
                type="button"
                className="theme-btn"
                onClick={handleCheckBalance}
                disabled={balanceLoading || !password}
              >
                {balanceLoading ? "Checking..." : "Check Now"}
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default ProfileInfo;